import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";

const buttonVariants = cva(
  "rounded-none inline-flex items-center justify-center gap-2 whitespace-nowrap font-mono text-[11px] uppercase tracking-[0.22em] transition-colors ring-0 outline-0 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "bg-brand-accent text-white hover:bg-brand-accent/85",
        secondary:
          "bg-transparent text-brand-text border border-brand-border hover:text-brand-accent",
        ghost: "bg-transparent text-brand-text hover:text-brand-accent",
        outline:
          "bg-transparent text-brand-text border border-brand-border hover:border-brand-accent hover:text-brand-accent data-[state=open]:border-brand-accent data-[state=open]:text-brand-accent",
      },
      size: {
        default: "h-12 px-6",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  title?: string;
  rightIcon?: React.ReactNode;
  leftIcon?: React.ReactNode;
  isLoading?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      className,
      variant,
      size,
      title,
      rightIcon,
      leftIcon,
      isLoading,
      children,
      ...props
    },
    ref
  ) => {
    return (
      <button
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
        disabled={isLoading || props.disabled}
      >
        {leftIcon &&
          (isLoading ? (
            <Loader2 size={16} className="animate-spin" />
          ) : (
            leftIcon
          ))}
        {!leftIcon && isLoading && (
          <Loader2 size={16} className="animate-spin" />
        )}

        {children ? children : title ? <p>{title}</p> : null}
        {
          rightIcon &&
            // (isLoading ? (
            //   <Loader2 size={16} className="animate-spin" />
            // ) : (
            rightIcon
          // ))}
        }
      </button>
    );
  }
);
Button.displayName = "Button";

export { Button, buttonVariants };
